export default function yupPasswordValidate(y) {
  y.addMethod(y.string, "passwordFormat", function () {
    return this.test("passwordFormat", "より強力なパスワードを入力してください。\n・文字数は8文字以上\n・「アルファベット」、「数字」、「記号(!@$#%+-_)」の3種類の組み合わせ", function (value) {
      return passwordFormatValidate(value);
    });
  });
}
export function passwordFormatValidate(value) {
  return /(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@$#%+\-_])/.test(value) && /^[a-zA-Z0-9!@$#%+\-_]+$/.test(value);
}